import styled from 'styled-components'
import Checkbox from 'antd/lib/checkbox'

const desktopOnly = (styles: string) => `
  @media (min-width: 1024px) {
    ${styles}
  }
  [data-force-desktop="true"]&,
  [data-force-desktop="true"] & {
    ${styles}
  }
`

export const Card = styled.article`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  cursor: pointer;

  &[data-selected="true"] {
    outline: 2px solid #abc9ff;
    background: #f1f6ff;
    padding: 4px;
    border-radius: 3px;
  }

  #CatalogCardBody {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);

    [data-force-desktop="false"] & {
      @media (max-width: 768px) {
        gap: var(--spacing-2);
        flex: 1;
      }
    }
  }

  #CatalogDesktopTopRow {
    display: none;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-12);

    ${desktopOnly(`
      display: flex;
    `)}
  }

  #CatalogMobileSeriesBadge {
    display: block;

    ${desktopOnly(`
      display: none;
    `)}
  }

  #CatalogDesktopFooterRow {
    display: none;
    align-items: center;
    justify-content: space-between;
    gap: var(--spacing-12);

    ${desktopOnly(`
      display: flex;
    `)}
  }

  .catalog-product-name {
    margin: 0;
    font: 600 16px/20px var(--font-barlow);
    letter-spacing: -0.1px;
    color: var(--neutral-darkest);
  }

  #CatalogMobileProductName {
    ${desktopOnly(`
      display: none;
    `)}
  }

  #CatalogProductSubtitle {
    margin: 0;
    font: 400 14px/22px var(--font-inter);
    color: var(--neutral-secondary);
  }

  #CatalogPriceRow {
    display: flex;
    align-items: baseline;
    gap: var(--spacing-4);
  }

  .catalog-price-value {
    font: 600 14px/20px var(--font-barlow);
    color: var(--neutral-darkest);
  }

  .catalog-price-quantity {
    font: 600 14px/24px var(--font-barlow);
    color: var(--neutral-muted);
  }

  #CatalogMobilePriceRow {
    display: flex;
    align-items: baseline;
    gap: var(--spacing-4);

    ${desktopOnly(`
      display: none;
    `)}
  }
`

export const ImageArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
  background: linear-gradient(-1.01deg, #d0d0d8 0%, #bfbfc7 50%, #d6d5dd 100%);
  overflow: hidden;
  position: relative;
  aspect-ratio: 3/4;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: opacity 0.3s ease;
  }

  .alt-image {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
  }

  &.has-alt:hover {
    .main-image {
      opacity: 0;
    }
    .alt-image {
      opacity: 1;
    }
  }
`

export const SerieBadge = styled.span`
  display: inline-flex;
  align-items: center;
  height: 0;
  font: 600 12px/18px var(--font-barlow);
  letter-spacing: 1.12px;
  text-transform: uppercase;
  color: var(--neutral-secondary);
  background: transparent;
  margin-bottom: 14px;

  ${desktopOnly(`
    height: 24px;
    padding: var(--spacing-8);
    margin-bottom: 0;
    border-radius: var(--spacing-4);
    background: var(--neutral-lightest-block);
  `)}

  &:not([data-serie]) {
    display: hidden;
  }

  &[data-serie='0'] {
     color: var(--series-xpo);
  }

  &[data-serie='1'] {
    color: var(--series-pro);
  }

  &[data-serie='2'] {
    color: var(--series-club);
  }
`

export const CompareButtonDesktop = styled(Checkbox)`
  display: inline-flex;
  align-items: center;
  width: 80px;
  height: 24px;
  padding: var(--spacing-4) var(--spacing-8);
  cursor: pointer;
  border: var(--border-regular) solid var(--neutral-border-med);
  background: var(--neutral-lightest-block);
  color: var(--neutral-body);
  font: 500 10px/14px var(--font-barlow);
  letter-spacing: 0.2px;
  text-transform: uppercase;

  .ant-checkbox {
    top: 0;
  }

  .ant-checkbox + span {
    padding-left: var(--spacing-4);
    padding-right: 0;
  }

  .ant-checkbox-inner {
    width: 12px;
    height: 12px;
    border-radius: 0;
    border: 1px solid var(--neutral-secondary);
    background: var(--neutral-white);
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    border-color: var(--neutral-white);
    ::after {
      border-color: var(--neutral-darkest);
      margin-left: -2px;
      width: 4px;
      height: 7px;
    }
  }

  .ant-checkbox-checked:after,
  .ant-checkbox-input:focus + .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  &:hover .ant-checkbox-inner {
    border-color: var(--neutral-secondary);
  }

  &:has(.ant-checkbox-checked) {
    background: var(--neutral-darkest);
    /* border-color: var(--neutral-darkest); */
    color: var(--neutral-white);
  }

  @media (max-width: 1023px) {
    margin-top: var(--spacing-4);
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CatalogProductCardV2/styledComponents.tsx